import _toConsumableArray from "D:/repo2/overtime-high/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "D:/repo2/overtime-high/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "core-js/modules/es.array.reduce.js";
import { isArray, isCustomBreakpoint, isObject, isResponsiveObjectLike, memoizedGet as get, mergeWith, objectToArrayNotation, runIfFn } from "@chakra-ui/utils";
import { parser } from "./parser";
import { pseudoSelectors } from "./pseudo";
var cache = {
  themeBreakpoints: [],
  breakpoints: [],
  breakpointValues: [],
  mediaQueries: []
};
/**
 *
 */

var calculateBreakpointAndMediaQueries = function calculateBreakpointAndMediaQueries(themeBreakpoints) {
  if (themeBreakpoints === void 0) {
    themeBreakpoints = [];
  } // caching here reduces execution time by factor 4-6x


  var isCached = cache.themeBreakpoints === themeBreakpoints;

  if (isCached) {
    return cache;
  }

  var _Object$entries$filte = Object.entries(themeBreakpoints).filter(function (_ref) {
    var _ref3 = _slicedToArray(_ref, 1),
        key = _ref3[0];

    return isCustomBreakpoint(key);
  }).reduce(function (carry, _ref2) {
    var _ref4 = _slicedToArray(_ref2, 2),
        breakpoint = _ref4[0],
        value = _ref4[1];

    carry.breakpoints.push(breakpoint);
    carry.breakpointValues.push(value);
    return carry;
  }, {
    breakpoints: [],
    breakpointValues: []
  }),
      breakpoints = _Object$entries$filte.breakpoints,
      breakpointValues = _Object$entries$filte.breakpointValues;

  var mediaQueries = [null].concat(_toConsumableArray(breakpointValues.map(function (bp) {
    return "@media screen and (min-width: " + bp + ")";
  }).slice(1)));
  cache.themeBreakpoints = themeBreakpoints;
  cache.mediaQueries = mediaQueries;
  cache.breakpointValues = breakpointValues;
  cache.breakpoints = breakpoints;
  return {
    breakpoints: breakpoints,
    mediaQueries: mediaQueries
  };
};

export var processResponsive = function processResponsive(styles) {
  return function (theme) {
    var computedStyles = {};

    var _calculateBreakpointA = calculateBreakpointAndMediaQueries(theme.breakpoints),
        breakpoints = _calculateBreakpointA.breakpoints,
        mediaQueries = _calculateBreakpointA.mediaQueries;

    for (var key in styles) {
      var value = runIfFn(styles[key], theme);

      if (value == null) {
        continue;
      }

      value = isResponsiveObjectLike(value, breakpoints) ? objectToArrayNotation(value, breakpoints) : value;

      if (!isArray(value)) {
        computedStyles[key] = value;
        continue;
      }

      var queries = value.slice(0, mediaQueries.length).length;

      for (var index = 0; index < queries; index += 1) {
        var media = mediaQueries[index];

        if (!media) {
          computedStyles[key] = value[index];
          continue;
        }

        computedStyles[media] = computedStyles[media] || {};

        if (value[index] == null) {
          continue;
        }

        computedStyles[media][key] = value[index];
      }
    }

    return computedStyles;
  };
};
export var css = function css(styleOrFn) {
  if (styleOrFn === void 0) {
    styleOrFn = {};
  }

  return function (props) {
    if (props === void 0) {
      props = {};
    }

    var theme = "theme" in props ? props.theme : props;
    var computedStyles = {};
    var styleObject = runIfFn(styleOrFn, theme);
    var styles = processResponsive(styleObject)(theme);

    for (var k in styles) {
      var _config, _config$transform, _config2, _config3, _config4, _config5;

      var x = styles[k];
      var val = runIfFn(x, theme);
      var key = k in pseudoSelectors ? pseudoSelectors[k] : k;
      var config = parser.config[key];

      if (config === true) {
        // shortcut definition
        config = {
          property: key,
          scale: key
        };
      }

      if (isObject(val)) {
        computedStyles[key] = css(val)(theme);
        continue;
      }

      var scale = get(theme, (_config = config) == null ? void 0 : _config.scale, {});
      var value = (_config$transform = (_config2 = config) == null ? void 0 : _config2.transform == null ? void 0 : _config2.transform(val, scale, props)) != null ? _config$transform : get(scale, val, val);
      /**
       * Useful for `layerStyle`, and `textStyle` to transform the returned
       * result since it might use theme tokens
       */

      value = (_config3 = config) != null && _config3.processResult ? css(value)(theme) : value;

      if ((_config4 = config) != null && _config4.properties) {
        var _iterator = _createForOfIteratorHelper(config.properties),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var property = _step.value;
            computedStyles[property] = value;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        continue;
      }

      if ((_config5 = config) != null && _config5.property) {
        /**
         * Used for styled-system configs that map to multiple computed properties.
         * For example, the `borderLeftRadius` computed keys based on rtl/ltr
         */
        if (config.property === "&") {
          computedStyles = mergeWith({}, computedStyles, value);
        } else {
          computedStyles[config.property] = value;
        }

        continue;
      }

      computedStyles[key] = value;
    }

    return computedStyles;
  };
};